import { UPDATE_TRANSCRIBE_CHANNEL, UPDATE_TRANSCRIBE_CALL } from "../actions";

const initialState = {
  channel: null,
  call: null,
};

export default function transcribeReducer(state, action) {
  //initialize state if its undef
  if (typeof state === "undefined") {
    return initialState;
  }
  switch (action.type) {
    case UPDATE_TRANSCRIBE_CHANNEL:
      state.channel = action.payload;
      break;
    case UPDATE_TRANSCRIBE_CALL:
      state.call = action.payload;
      break;
    default:
      break;
  }

  return state;
}
